import * as teamsJs from "@microsoft/teams-js";

let initialized = false;
let cachedToken: { value: string; expiresAt: number } | null = null;

export async function ensureTeamsInit(): Promise<boolean> {
  if (initialized) return true;
  try {
    await teamsJs.app.initialize();
    initialized = true;
    return true;
  } catch {
    // Not running inside Teams (e.g. browser dev) — caller should fallback.
    return false;
  }
}

export async function getAuthToken(): Promise<string | null> {
  if (cachedToken && cachedToken.expiresAt - Date.now() > 60_000) return cachedToken.value;
  const inTeams = await ensureTeamsInit();
  if (!inTeams) return null;
  try {
    const token = await teamsJs.authentication.getAuthToken({
      resources: import.meta.env.VITE_AAD_RESOURCE ? [import.meta.env.VITE_AAD_RESOURCE] : undefined,
      silent: true,
    });
    // Tokens issued by Teams SSO are typically valid ~1h; we re-fetch defensively.
    cachedToken = { value: token, expiresAt: Date.now() + 50 * 60 * 1000 };
    return token;
  } catch (e) {
    console.error("Teams SSO failed", e);
    return null;
  }
}

export async function getTeamsContext() {
  const inTeams = await ensureTeamsInit();
  if (!inTeams) return null;
  return teamsJs.app.getContext();
}

export function isInTeams() {
  return initialized;
}
